import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table-index-cell" }
const _hoisted_2 = { class: "table-index-cell__order" }
const _hoisted_3 = { class: "table-index-cell__id" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_word_break_column = _resolveComponent("word-break-column")!
  const _component_BaseLink = _resolveComponent("BaseLink")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    "empty-text": "Không có dữ liệu kế hoạch sửa chữa năm",
    size: "medium",
    border: true,
    data: _ctx.items
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "STT",
        width: "70"
      }, {
        default: _withCtx((scope) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.indexCal(scope.$index, _ctx.curPage, _ctx.perPage)), 1),
            _createElementVNode("span", _hoisted_3, "(" + _toDisplayString(scope.row.id) + ")", 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_word_break_column, {
        width: "100",
        "header-title": "Số v/bản",
        property: "so_van_ban"
      }),
      _createVNode(_component_el_table_column, {
        label: "Cấp sửa chữa",
        width: "300"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_BaseLink, {
            to: {
            name: 'chi-tiet-cap-sua-chua',
            params: {
              id: scope.row.cap_sua_chua.id,
            },
          }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(scope.row.cap_sua_chua.ten_cap_sc), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Nhóm toa xe",
        width: "180"
      }, {
        default: _withCtx((scope) => [
          (scope.row.danh_muc_toa_xe)
            ? (_openBlock(), _createBlock(_component_BaseLink, {
                key: 0,
                to: {
            name: 'chi-tiet-danh-muc-toa-xe',
            params: {
              id: scope.row.danh_muc_toa_xe.id,
            },
          }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.danh_muc_toa_xe.ten_danh_muc), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        width: "180",
        label: "Đơn vị"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.don_vi.ten_don_vi), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_word_break_column, {
        width: "100",
        "header-title": "Năm",
        property: "nam"
      }),
      _createVNode(_component_el_table_column, {
        "min-width": "250",
        label: "Ghi chú"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.ghi_chu), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        width: "50",
        fixed: "right",
        align: "center"
      }, {
        default: _withCtx((scope) => [
          _createVNode(_component_Setting, {
            actions: _ctx.getSettingActions(scope.row)
          }, null, 8, ["actions"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}